// import $ from 'jquery';
import { handleValidation } from "./validation.js";
import '../utils/altcha.min.js';

const handleFormSubmit =  () => {
  function formSubmit() {
    const forms = document.querySelectorAll('.footer__form .js-sk-form');
    forms.forEach((form) => {
      const message = form.nextElementSibling;
      const submit = form.querySelector('button[type=submit');
      const loader = form.previousElementSibling;

      const checkTelValue = (tel) => {
        if (!tel || tel.type !== "tel") return;
        let value = tel.value.replace(/[^\d+]/g, "");

        if (value.includes("+")) {
          value = value.replace(/\+/g, "");
          value = "+" + value;
        }

        tel.value = value;
      };

      form && form.addEventListener("input", (e) => {
        checkTelValue(e.target);
      });

      form.addEventListener('submit', function(e){
        e.preventDefault()
        const valid = handleValidation(form);
    
        if(!valid) {
          return
        }

        submit?.setAttribute('disabled', true)
        loader.classList.remove('hidden')

        const formData = new FormData(this);
        fetch(themeVars.ajax_url, {
          method: "POST",
          body: formData,
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          },
        })
        .then((response) => {
          if (!response.ok) throw new Error("Network response was not ok");
          return response.json();
        })
        .then(() => {
          submit.setAttribute('disabled', false)
          loader.classList.add('hidden');
          setTimeout(() => {
            form.remove();
            message.classList.remove('hidden');
          }, 300);
        })
        .catch((error) => {
          console.error("There was a problem with the fetch operation:", error);
        });
      })
    });
  }

  return {
    init() {
      formSubmit();
    },
  }
}

export {
  handleFormSubmit,
};
